import { useSelector } from 'react-redux';
import { NextPage } from 'next';

import { tariffs } from '@r1-frontend/api-domru/api-content/v1/cities/tariffs';
import {
    TResponseDto as TTariffsResponseDto,
} from '@r1-frontend/api-domru/api-content/v1/cities/tariffs/dto/ResponseDto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import Layout from '~/src/features/_layout';
import Request from '~/src/features/request';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getCookie } from '~/src/helpers/cookie';
import getRequester from '~/src/helpers/getRequester';
import { saveTariffs } from '~/src/store/actions/bundles';
import { setTariffsForInternet } from '~/src/store/actions/internet';
import { selectCompanyName } from '~/src/store/selectors/city';
import selectProviderId from '~/src/store/selectors/selectProviderId';

interface IProps {
    city: ICurrentCity,
}

const RequestPage: NextPage<IProps> = ({ city }) => {
    const companyName = useSelector(selectCompanyName);

    return (
        <Layout
            title={`Заявка на подключение интернета и цифрового телевидения онлайн от ${companyName} в ${city.cityIn}`}
            description={`Официальный сайт провайдера ${companyName} в ${city.cityIn} | Оставьте заявку на подключение домашнего интернета и цифрового ТВ. Скоростное подключение для новых клиентов!`}
            withMenu={true}
            withChat={false}
            withFooter={false}
        >
            <Request/>
        </Layout>
    );
};

RequestPage.getInitialProps = async(options) => {
    await initialProps(options, { isNeedAuthData: true });
    const { store } = options;
    const state = store.getState();
    const { city: { currentCity: city } } = state;

    const providerId = Number(getCookie('providerId', options.req) || selectProviderId(state));

    const internetTariffs = state.internet.tariffs;
    const bandlesTariffs = state.bundles.tariffs.allIds;
    const hasTariffs = internetTariffs && !!internetTariffs.length && bandlesTariffs && !!bandlesTariffs.length;

    const doRequest = getRequester(options.req);

    if (!hasTariffs) {
        const tariffsResponse = await doRequest.apiContent<TTariffsResponseDto>({
            ...tariffs({ providerId }),
            withProvider: false,
        });

        if (tariffsResponse.isSuccess) {
            store.dispatch(setTariffsForInternet(tariffsResponse.payload.mono));
            store.dispatch(saveTariffs(tariffsResponse.payload.bundles));
        }
    }

    return ({
        city,
    });
};

export default RequestPage;
